import type {
  ImportRunStatus,
  ImportRunType,
  ImportSourceType,
  StockImportConfigShortModel,
  StockImportLogModel,
} from '../types/stockImports.types'

export const runStatusMap: Record<
  ImportRunStatus,
  { label: string; color: string }
> = {
  SUCCESS: { label: 'Успешно', color: 'success' },
  WARNING: { label: 'Предупреждение', color: 'warning' },
  ERROR: { label: 'Ошибка', color: 'error' },
  UNCHANGED: { label: 'Без изменений', color: 'default' },
}

export const sourceTypeLabels: Record<ImportSourceType, string> = {
  EMAIL: 'Системная почта',
  URL: 'Облачное хранилище / Прямая ссылка',
  MANUAL: 'Ручная загрузка',
  CUSTOM_IMAP: 'Личная почта поставщика',
}

export const runTypeLabels: Record<ImportRunType, string> = {
  MANUAL: 'Пользователь',
  AUTO: 'Система',
}

export const formatMs = (value?: number) => {
  if (value === undefined || value === null) return '—'
  if (value < 1000) return `${value} мс`
  return `${(value / 1000).toFixed(1)} с`
}

export type LogCounterField = keyof Pick<
  StockImportLogModel,
  | 'totalRows'
  | 'loadedRows'
  | 'inStockRows'
  | 'groupRows'
  | 'missingRows'
  | 'hasMissingSkuData'
>

export const LOG_COUNTERS: Array<{
  field: LogCounterField
  label: string
  hint: string
}> = [
  {
    field: 'totalRows',
    label: 'Всего',
    hint: 'Все строки файла в выбранном диапазоне, включая строки-заголовки групп.',
  },
  {
    field: 'loadedRows',
    label: 'Загружено',
    hint: 'Сколько товаров каталога получили остаток. Несколько строк одного товара считаются одним товаром, их остатки суммируются. Поэтому сумма «Загружено», «Не загружено» и «Групп» может быть меньше «Всего».',
  },
  {
    field: 'inStockRows',
    label: 'С остатком',
    hint: 'Сколько из загруженных товаров имеют остаток больше 0.',
  },
  {
    field: 'groupRows',
    label: 'Групп',
    hint: 'Строки-заголовки групп и разделов: в них нет ни артикула, ни штрихкода, ни количества. Это не ошибки.',
  },
  {
    field: 'missingRows',
    label: 'Не загружено',
    hint: 'Строки файла, которые не загрузились: товар не найден, бренд другой или не указан, нет количества, строка отсеяна фильтрами брендов. Подробности — в деталях загрузки.',
  },
  {
    field: 'hasMissingSkuData',
    label: 'Отчёт',
    hint: 'Есть ли построчный отчёт по незагруженным строкам. Отчёт хранится для 10 последних загрузок каждой настройки.',
  },
]

export const MISSING_SKU_REPORT_DELETED_TEXT =
  'Подробности хранятся для 10 последних загрузок настройки'

export const getLogSourceInfo = (
  log: Pick<StockImportLogModel, 'productSupplier' | 'store'>,
  config: StockImportConfigShortModel | undefined
) => ({
  supplierName: (log.productSupplier ?? config?.productSupplier)?.description,
  storeName: (log.store ?? config?.store)?.description,
  sourceTypeLabel: config ? sourceTypeLabels[config.sourceType] : undefined,
})
